import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

const initialState = {
    status: null,
    categoriesData: null,
    message: null,
}

export const createcategoriescatalog = createAsyncThunk("createcategoriescatalog", async (data) => {
    try {
        const response = await fetch(`/api/preExistingCollections`, {
            method: 'POST',
            headers: {
                Accept: "application/json",
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(data)
        })
        if (!response.ok) {
            throw new Error('Failed to create pre-existing categories catalog');
        }
        return await response.json();
        // return response;
    } catch (error) {
        throw new Error('Failed to create pre-existing categories catalog', error);
    }
});

const preExistingCategoriesCatalog = createSlice({
    name: "preExistingCategoriesCatalog",
    initialState,
    extraReducers: (builder) => {
        builder.addCase(createcategoriescatalog.pending, (state) => {
            state.status= "Inprogress"
            state.categoriesData= null
            state.message = null
        });
        builder.addCase(createcategoriescatalog.fulfilled, (state, action) => {
            state.status= "SUCCESS"
            state.categoriesData= action.payload.data
            state.message = "Pre-Existing Collection Completed"
        });
        builder.addCase(createcategoriescatalog.rejected, (state) => {
            state.status= "FAILED"
            state.categoriesData= null
            state.message = "Pre-Existing Collection failed"
        });
    }
})

export default preExistingCategoriesCatalog.reducer